const RELOAD_KEY = 'chunk_load_reload_at';
const RELOAD_COOLDOWN_MS = 10_000;

export function isChunkLoadError(error: unknown): boolean {
  const err = unwrapError(error);
  if (!err) return false;

  const message = String(err.message ?? '');
  const name = String(err.name ?? '');

  return (
    name === 'ChunkLoadError' ||
    /Loading chunk [\w.-]+ failed/i.test(message) ||
    /Failed to fetch dynamically imported module/i.test(message) ||
    /error loading dynamically imported module/i.test(message) ||
    /Importing a module script failed/i.test(message) ||
    /Failed to load module script/i.test(message) ||
    /MIME type of ["']text\/html["']/i.test(message)
  );
}

function unwrapError(error: unknown): { message?: string; name?: string } | null {
  if (!error) return null;

  if (typeof error === 'object' && error !== null && 'rejection' in error) {
    return unwrapError((error as { rejection: unknown }).rejection);
  }

  if (error instanceof Error) return error;

  if (typeof error === 'object' && error !== null && 'message' in error) {
    return error as { message?: string; name?: string };
  }

  return { message: String(error) };
}

/**
 * Forces a full reload so the browser picks up the new index.html and chunk hashes.
 * Returns true if a reload was triggered.
 */
export function reloadOnChunkLoadError(error: unknown): boolean {
  if (!isChunkLoadError(error)) return false;

  try {
    const lastReload = sessionStorage.getItem(RELOAD_KEY);
    if (lastReload && Date.now() - Number(lastReload) < RELOAD_COOLDOWN_MS) {
      sessionStorage.removeItem(RELOAD_KEY);
      return false;
    }
    sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
  } catch {
    // sessionStorage may be unavailable; still attempt reload once
  }

  globalThis.location.reload();
  return true;
}
